
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface PortionSizeInputProps {
  value: string;
  unit: string;
  onValueChange: (value: string) => void;
  onUnitChange: (unit: string) => void;
  error?: string | null;
}

export const PortionSizeInput = ({
  value,
  unit,
  onValueChange,
  onUnitChange,
  error
}: PortionSizeInputProps) => {
  return (
    <div className="space-y-2.5">
      <Label className="text-black font-medium text-base">Portion Size *</Label>
      <div className="flex gap-4">
        <div className="flex-1">
          <Input
            type="number"
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            placeholder="Enter size"
            min="0"
            step="0.1"
            className={`h-12 rounded-xl border-[#E5E5E5] bg-[#EDEDED] ${
              error ? 'border-red-500 focus-visible:ring-red-500' : ''
            }`}
          />
        </div>
        <div className="w-[140px]">
          <Select value={unit} onValueChange={onUnitChange}>
            <SelectTrigger className="h-12 rounded-xl border-[#E5E5E5] bg-[#EDEDED]">
              <SelectValue placeholder="Unit" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="servings">servings</SelectItem>
              <SelectItem value="oz">oz</SelectItem>
              <SelectItem value="g">g</SelectItem>
              <SelectItem value="ml">ml</SelectItem>
              <SelectItem value="pieces">pieces</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      {error && (
        <p className="text-sm text-red-500 mt-1">{error}</p>
      )}
    </div>
  );
};
